export default __webpack_public_path__ + "media/music/316c9f3027d36f70fb75990066d69020.mp3";